<div class="d-flex align-items-center">
    Si tiene el tag:
    <div class="flex-grow-1 ps-1">
        <ng-select [items]="categorias" bindLabel="nombre" [formControl]="categoriaSeleccionadaControl"
            [clearable]="false">
            <ng-template ng-label-tmp ng-option-tmp let-item="item">
                {{item.nombre | traducir}}
            </ng-template>
        </ng-select>
    </div>
    <div class="ps-1 flex-grow-1">
        <ng-select [items]="etiquetas" bindLabel="valor" [formControl]="etiquetaSeleccionadaControl"
            [clearable]="false">
            <ng-template ng-label-tmp ng-option-tmp let-item="item">
                {{item.valor | traducir}}
            </ng-template>
        </ng-select>
    </div>
    <div class="col flex-grow-0 text-end my-auto" [class.seleccionable]="borrarOperandoCmd.puedeEjecutarse"
        [command]="borrarOperandoCmd">
        <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
    </div>
</div>
